import Route from '@ember/routing/route';
import { buildUrl } from 'garaje/utils/url-builder';

export default class AuthRoute extends Route {
  beforeModel() {
    window.location = buildUrl(`/a/auth/v0/authorize${window.location.search}`);
  }
}
